import React from "react";
import BackArrow from "../Icons/BackArrow/BackArrow";
import { useNavigate } from "react-router-dom";
function Navigation() {
  const navigate = useNavigate();
  return (
    <div>
      <BackArrow onClick={() => navigate(-1)} />
    </div>
  );
}

export default Navigation;
